import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import english from './translations/en.json'
import ukrainian from './translations/uk.json'
import german from './translations/de.json'
import french from './translations/fr.json'
import danish from './translations/da.json'
import italian from './translations/it.json'
import spanish from './translations/es.json'
import chinese from './translations/zh.json'
import polish from './translations/pl.json'

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: english,
  },
  uk: {
    translation: ukrainian,
  },
  de: {
    translation: german,
  },
  fr: {
    translation: french,
  },
  da: {
    translation: danish,
  },
  it: {
    translation: italian,
  },
  es: {
    translation: spanish,
  },
  zh: {
    translation: chinese,
  },
  pl: {
    translation: polish,
  },
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
